const REDIRECT_INTENT_KEY = 'mfl_redirect_intent';

/**
 * Save redirect intent to localStorage
 * @param {string} pathname - The pathname to redirect to after authentication
 */
export const saveRedirectIntent = (pathname) => {
    if (pathname && pathname !== '/login' && pathname !== '/sign-up') {
        localStorage.setItem(REDIRECT_INTENT_KEY, pathname);
    }
};

/**
 * Get redirect intent from localStorage
 * @returns {string|null} The saved redirect pathname or null
 */
export const getRedirectIntent = () => {
    const intent = localStorage.getItem(REDIRECT_INTENT_KEY);
    return intent || null;
};

/**
 * Clear redirect intent from localStorage
 */
export const clearRedirectIntent = () => {
    localStorage.removeItem(REDIRECT_INTENT_KEY);
};
